const NAMESPACE = 'INSTALL_DEPENDENT_APP' as const;

const MODAL_KEY = `${NAMESPACE}/installDependentAppModal` as const;

const FETCH_FILES_PAGE_SIZE = 10 as const;

const SEARCH_FILES_DEBOUNCE_THRESHOLD_MS = 300;

export default {
  FETCH_FILES_PAGE_SIZE,
  NAMESPACE,
  MODAL_KEY,
  SEARCH_FILES_DEBOUNCE_THRESHOLD_MS,
};
